import { DateTime } from 'luxon';
import { QUESTIONNAIRE_ACTIVE_DATA } from './active.data';
import {
  QuestionnaireActiveFormField,
  QuestionnaireActiveOption
} from './active.interface';

/**
 * @description Selects the Questionnaire Active state from the store.
 * @param {string} date Date string to compare.
 * @returns {boolean} Whether the date is greater than one month ago.
 */
export const qUtilsActiveIsDateGreaterThanOneMonth = (
  date: string
): boolean => {
  if (!date) return true;
  const now = DateTime.now();
  const targetDate = DateTime.fromISO(date);
  const diffInMonths = now.diff(targetDate, 'months').months;
  return diffInMonths > 1;
};

/**
 * @description Find a default option for a given key in the questionnaire active form.
 * @param {string} key Key to search for in the options.
 * @returns {(QuestionnaireActiveOption | null)} The default option or null.
 */
export const qUtilsActiveFindDefaultOption = (
  key: QuestionnaireActiveFormField
): QuestionnaireActiveOption | null => {
  return (
    QUESTIONNAIRE_ACTIVE_DATA[key]?.options?.find(
      (opt) => opt.isDefault === true
    ) ?? null
  );
};

/**
 * @description Filter options for a given key in the questionnaire active form.
 * @param {QuestionnaireActiveFormField} key Key to filter options by.
 * @returns {Array<QuestionnaireActiveOption>} The filtered default options.
 */
export const qUtilsActiveFilterDefaultOption = (
  key: QuestionnaireActiveFormField
): Array<QuestionnaireActiveOption> => {
  return (
    QUESTIONNAIRE_ACTIVE_DATA[key]?.options?.filter(
      (opt) => opt.isDefault === true
    ) ?? []
  );
};
